module.exports = __webpack_public_path__ + "img/53.8b1a6d10.svg";